import Common from '../common/CommonNctv';
import Util from '../common/Util';

export let cardItem = (_data={}, _from='live', _classType='E') => {
/*
 card 썸네일 + 정보형 : .card-thumbnail
 card full : .card-full
 모바일에서 width고정된 작은 카드: .is-small
 모바일에서 width고정된 카드: .is-big
 관련 동영상 목록에서 재생중인 카드 : .is-playing
*/
    let com = Common.instance;

    const myUniqueId = _data.id +"_"+ Math.random().toString(36).substr(2, 9);

    let classType = {
        'A': 'card-thumbnail is-big',
        'B': 'card-thumbnail is-small',
        'C': 'card-full is-big',
        'D': 'card-full',
        'E': 'card-thumbnail'
    }[_classType];

    const defaultThumbnail = '';

    //검색에서 현재 시청자수 LIVE로 표시 
    let currentViewCount = _data.providerCurrentViewCount;
    if(!_data.providerCurrentViewCount){
        currentViewCount = _from === 'search' ? 'LIVE' : '0';
    }

    //썸네일 체크
    let thmbnail = new Image();
    thmbnail.src = (_data.thumbnail!=='')?_data.thumbnail: `${com.staticPath}/img/${com.ip}/noimage.gif`;

    thmbnail.onload = () =>{
        $(`[data-card = "${myUniqueId}"] .thumb-img`)
            .css('background-image', `url(${thmbnail.src})`)
            .removeClass('is-loading');
    };

    thmbnail.onerror = () =>{
        $(`[data-card = "${myUniqueId}"] .thumb-img`)
        .css('background-image', `url(${_data.channelThumbnail})`)
        .removeClass('is-loading');
    };


    let contentTitle = _data.title || `${_data.channelName} 님의 ${com.ip.toUpperCase()} 플레이 영상`;
    let under30Days = (((+new Date()) - parseInt(_data.updateDate))/86400000) < 30;

    return `
<li class="item" data-card="${myUniqueId}">
    <div class="card ${classType}">
        <div class="card-container">
            <div class="card-header">
                <a href="/view?tv=${com.ip}&id=${_data.id}&from=${_from}">
                    <div class="card-header-thumb">
                            <div class="thumb-img is-loading">${contentTitle}</div>
                            <span class="thumb-play">${require('../../svg/play.svg')}</span>
                    </div>
                    ${_from=='recommend'? '': `
                    <div class="card-header-info">
                        ${_data.ncstreaming? `<span class="info-ncStreaming badge-ncStreaming"> <em class="badge-ncStreaming-text">NC Streaming</em></span>`:`` }
                        ${_data.videoType==='live' && _data.liveStatus==='live'?
                            `<span class="info-viewCount">${currentViewCount}</span>`:``
                        }
                    </div>`}
                </a>
            </div>
            <div class="card-body">
                <div class="card-content">
                    <div class="card-content-title"><a href="/view?tv=${com.ip}&id=${_data.id}&from=${_from}">${contentTitle}</a></div>
                    ${_data.gameData? `<div class="card-content-log">#${_data.gameData}</div> `: ''}
                    ${_from=='recommend'? '': `
                    <div class="card-content-author" ${_from=='official'? 'style="display: none;"': ''}>
                        <img src="${_data.channelThumbnail}" class="author-img" alt=""> ${_data.channelName}
                    </div>`}
                </div>
                ${_from=='recommend'? '': `
                <div class="card-info">
                    <div class="card-info-meta">
                        <span class="meta-origin">${require('../../svg/'+_data.provider+'.svg')}</span>
                        <span class="meta-duration">${_data.playtime? Util.makeTime(_data.playtime):''}</span>
                        ${under30Days?`
                        <span class="meta-like">
                            <span class="meta-like-icon">${require('../../svg/heart-fill.svg')}</span>
                            ${Util.addThousandSeparatorCommas(_data.providerLikeCount)}
                        </span>
                        `:``}
                    </div>
                    ${_data.zone.zoneName && _data.videoType==='live' ? `<div class="card-info-zone"><a href="${encodeURI(`/search?tv=bns&query=${_data.zone.zoneName}&gamelog=true`)}"><span class="zone-icon">${require('../../svg/zone.svg')}</span> ${_data.zone.zoneName}</a></div>`:`` }
                </div>`}
            </div>
        </div>
    </div>
</li>`;
};
